import { render } from "./TheMyCollectionModalWindow.vue?vue&type=template&id=822e139e&scoped=true&ts=true"
import script from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionModalWindow.vue?vue&type=script&lang=ts"

import "./TheMyCollectionModalWindow.vue?vue&type=style&index=0&id=822e139e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822e139e"]])

export default __exports__